const ChatIcon = () => {
  return (
    <svg width="29" height="29" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M25 36C25 40.9706 30.3726 45 37 45C38.6924 45 40.303 44.7372 41.7631 44.2631L46 48V41.9531C47.8671 40.3666 49 38.2825 49 36C49 31.0294 43.6274 27 37 27C30.3726 27 25 31.0294 25 36Z"
        fill="#19005A"
        stroke="url(#paint2_linear)"
        strokeWidth="2"
        strokeMiterlimit="2.61313"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 41C39.8366 41 47 35.6274 47 29C47 22.3726 39.8366 17 31 17C22.1634 17 15 22.3726 15 29C15 32.0433 16.5105 34.8221 19 36.9375V43L24.1517 39.8483C26.2277 40.5868 28.5495 41 31 41Z"
        fill="#19005A"
        stroke="url(#paint3_linear)"
        strokeWidth="2"
        strokeMiterlimit="2.61313"
        strokeLinejoin="round"
      />
      <path
        d="M24 33H31"
        stroke="url(#paint4_linear)"
        strokeWidth="2"
        strokeMiterlimit="2.61313"
        strokeLinecap="round"
      />
      <path
        d="M24 29H38"
        stroke="url(#paint5_linear)"
        strokeWidth="2"
        strokeMiterlimit="2.61313"
        strokeLinecap="round"
      />
      <path
        d="M24 25H38"
        stroke="url(#paint6_linear)"
        strokeWidth="2"
        strokeMiterlimit="2.61313"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint2_linear"
          x1="25"
          y1="27"
          x2="42.867"
          y2="50.3929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6446F0" />
          <stop offset="1" stopColor="#AFA0FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="45"
          y1="17"
          x2="19"
          y2="43"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2F5FF" />
          <stop offset="1" stopColor="#009BFF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="23.7308"
          y1="33"
          x2="31.2692"
          y2="33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAF541" />
          <stop offset="1" stopColor="#B4192D" />
        </linearGradient>
        <linearGradient
          id="paint5_linear"
          x1="23.4615"
          y1="29"
          x2="38.5385"
          y2="29"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0698C" />
          <stop offset="1" stopColor="#5A00FA" />
        </linearGradient>
        <linearGradient
          id="paint6_linear"
          x1="23.4615"
          y1="25"
          x2="38.5385"
          y2="25"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FAF541" />
          <stop offset="1" stopColor="#B4192D" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ChatIcon;
